<template>
  <div>
    <div v-if="sortIcons">
      <ul v-for="(row, index) of sortByPosition(icons)" :key="index" class="bottom-border">
        <li v-for="(column, index) of row" 
          :key="index" 
          @click="iconSelected(column)" 
          :class="[selectedIconClass(column)]">
          <i v-if="column.icon" class="iconfont2" :class="column.icon"></i>
          <p v-if="column.label" >{{ column.label }}</p>
        </li>
      </ul>
    </div>
    <ul v-else>
      <li v-for="(icon, index) of icons" 
        :key="index" 
        @click="iconSelected(icon)" 
        :class="[selectedIconClass(icon)]">
        <i v-if="icon.icon" class="iconfont2" :class="icon.icon"></i>
        <p v-if="icon.label" >{{ icon.label }}</p>
      </li>
    </ul>
  </div>
</template>
<style scoped>
  ul {
    list-style: none;
    padding:0px;
    width: 757px;
  }
  ul.bottom-border {
    padding-bottom:9px;
    border-bottom: 1px solid #C5C5C5;
  }
  ul > li {
    display: inline-block;
    border: 1px solid #C5C5C5;
    overflow: initial !important;
    cursor: pointer;
    height: auto;
    line-height: 32px !important;
    width: 63px;
    text-align: center;
    margin-left: -1px;
    margin-top:-1px;
  }
  ul > li:hover {
    background-color: #F5F7FA;
  }
  ul > li.selected {
    font-weight: 700;
    color: #978067;
  }
  ul > li > i {
    font-size: 22px;
  }
  ul > li > p {
    font-size: 12px;
    white-space: nowrap;
    margin: 0px;
    line-height: normal;
  }
</style>
<script>
export default {
  name: "IconList",
  props: {
    icons: { type: Array, default: () => [] },
    sortIcons: { type: Boolean, default: () => false },
  },
  data() {
    return {
      selectedIcon : null
    }
  },
  watch: {
    icons() {
      this.selectedIcon = null;
    }
  },
  methods: {
    iconSelected(icon) {
      this.$emit('iconSelected', icon);
      this.selectedIcon = icon.icon;
    },
    selectedIconClass(icon) {
      return icon.icon == this.selectedIcon ? 'selected' : '';
    },
    sortByPosition(icons) {
      var sortedIcons = [];
      var emptyslot = {};
      for(var icon of icons) {
        if (icon.icon == 'emptyslot') {
          emptyslot = icon;
          continue;
        }
        if (typeof sortedIcons[icon.position.row -1] == 'undefined') {
          sortedIcons[icon.position.row - 1] = []
        }
        sortedIcons[icon.position.row - 1][icon.position.column - 1] = icon;
      }
      sortedIcons.push([emptyslot]);
      return sortedIcons;
    },
  }
};
</script>
